import type { ReactElement } from 'react';
import React from 'react';
import { capitalize } from 'lodash';
import Breadcrumb from 'atom-components/breadcrumb-lite';
import { MarkingPath } from 'pages/marking/routes';
import type { PageAction } from './types';

type Props = {
  pageAction: PageAction;
};

export default function Breadcrumbs({ pageAction }: Props): ReactElement {
  return (
    <Breadcrumb>
      <Breadcrumb.Item href={MarkingPath.MarkerDashboard}>Marking</Breadcrumb.Item>
      <Breadcrumb.Item href={MarkingPath.MarkingGroups}>Marking Groups</Breadcrumb.Item>
      <Breadcrumb.Item active>{capitalize(pageAction)} Marking Group</Breadcrumb.Item>
    </Breadcrumb>
  );
}
